import { render, staticRenderFns } from "./installment-selector.vue?vue&type=template&id=1e3a5380&scoped=true"
import script from "./installment-selector.vue?vue&type=script&lang=ts"
export * from "./installment-selector.vue?vue&type=script&lang=ts"
import style0 from "./installment-selector.vue?vue&type=style&index=0&id=1e3a5380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3a5380",
  null
  
)

export default component.exports